module.exports = __webpack_public_path__ + "img/2436654.abf583ac.png";